import IPPageNumber from "app/pages/InteractiveProposal/InteractiveProposalDownload/IPPageNuber";
import HexagonImg from "app/pages/InteractiveProposal/images/hexagonImg.png";
import { getSessionStore } from "app/utils/sessionStore";
import { getThemeColors, getUSANumberFormat } from "app/utils/utils";
import { getColorVariations } from "app/utils/colorUtils";

const tableHeaders = [
  { label: "Plan Year" },
  { label: "Account Value" },
  { label: "Surrender Value" },
  { label: "Death Benefit" },
  { label: "Financing Balance" },
  { label: "Outside Assets" },
  { label: "Interest Credits" },
];

interface AppendixRow {
  planYear: number;
  preCredit: {
    actualAccountValue: number;
    actualSurrenderValue: number;
    actualDeathBenefit: number;
    actualFinancingBalance: number;
    totalOutsideAssets: number;
    interestCredits: number;
  };
}

interface IRCAppendixPageProps {
  performance: AppendixRow[];
  insuranceCompanyName?: string;
  pageNumber: string | number;
  isNewPage?: boolean;
}

const IRCAppendixPage = ({
  performance,
  insuranceCompanyName,
  pageNumber,
  isNewPage = false,
}: IRCAppendixPageProps) => {
  const { branding } = getSessionStore("lookUpResponse");
  const { secondaryColor } = getThemeColors(branding);
  const colorVariations = getColorVariations(secondaryColor, tableHeaders.length).reverse();

  return (
    <div className="flex flex-col h-full relative min-h-screen">
      <div className="relative z-20 px-[2em] w-full max-w-[56em] mx-auto p-[1.75em]">
        {!isNewPage && (
          <>
            <div className="text-xl font-bold mb-3 text-center interactive-proposal-text conthrax-font">
              Appendix
            </div>
            {insuranceCompanyName && (
              <p className="mb-2 text-base conthrax-font" style={{ color: "#495057" }}>
                {insuranceCompanyName} – Please see full insurance company illustration
              </p>
            )}
          </>
        )}

        <table className="w-full border-collapse">
          <thead className="text-white">
            <tr>
              {tableHeaders.map((h, i) => (
                <th
                  key={i}
                  className="p-1 text-center pdf_table_border border-white font-semibold"
                  style={{ backgroundColor: colorVariations[i], fontSize: "9px" }}
                >
                  {h.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {performance?.map((row, i) => {
              const m = row.preCredit;
              return (
                <tr
                  key={i}
                  style={{ backgroundColor: "#EEEEEE", color: "#000000", fontSize: "9px" }}
                >
                  <td className="p-1 text-center pdf_table_border border-white">{row.planYear}</td>
                  <td className="p-1 text-center pdf_table_border border-white">
                    ${getUSANumberFormat(m.actualAccountValue, false)}
                  </td>
                  <td className="p-1 text-center pdf_table_border border-white">
                    ${getUSANumberFormat(m.actualSurrenderValue, false)}
                  </td>
                  <td className="p-1 text-center pdf_table_border border-white">
                    ${getUSANumberFormat(m.actualDeathBenefit, false)}
                  </td>
                  <td className="p-1 text-center pdf_table_border border-white">
                    ${getUSANumberFormat(m.actualFinancingBalance, false)}
                  </td>
                  <td className="p-1 text-center pdf_table_border border-white">
                    ${getUSANumberFormat(m.totalOutsideAssets, false)}
                  </td>
                  <td className="p-1 text-center pdf_table_border border-white">
                    ${getUSANumberFormat(m.interestCredits, false)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="absolute bottom-0 left-0 w-full">
        <div
          className="h-[350px] bg-cover bg-center"
          style={{ backgroundImage: `url(${HexagonImg})` }}
        />
        <div className="px-[4em] w-full max-w-[56em] mx-auto p-[1.75em] pt-1">
          <IPPageNumber number={pageNumber} />
        </div>
      </div>
    </div>
  );
};

export default IRCAppendixPage;
